import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
//引入通用样式
import './assets/css/common.css'
// 引入响应式样式
import './assets/css/responsive.css'
// 引入微信浏览器专用样式
import './assets/css/wechat.css'
// 引入移动端适配工具
import { initMobileAdapter } from './utils/mobile'
// 引入设备重定向服务
import { initDeviceRedirect } from './utils/deviceRedirect'
// 引入微信浏览器调试工具
import { initWechatDebug } from './utils/wechatDebug'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

Vue.config.productionTip = false

// 初始化移动端适配
initMobileAdapter()

// 初始化设备重定向
initDeviceRedirect()

// 初始化微信浏览器调试工具（仅在开发环境启用）
initWechatDebug(false, process.env.NODE_ENV === 'development')

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
